var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 34.499,
    y1: 137.068,
    x2: 106.423,
    y2: 137.068
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 63.197,137.068 30.903,137.068 30.903,167.28 30.903,207.788 30.903,238 63.197,238 84.414,238 171.586,238 192.803,238  225.097,238 225.097,207.788 225.097,167.28 225.097,137.068 192.803,137.068  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M94.841,187.513c0-17.778,9.338-32.823,22.205-37.857H61.096c0,9.509-7.883,17.218-17.606,17.218v41.322 c9.724,0,17.606,7.709,17.606,17.218h56.064C104.235,220.423,94.841,205.343,94.841,187.513z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 68.663,
    cy: 187.534,
    rx: 7.192,
    ry: 7.209
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M194.904,149.656h-55.95c12.866,5.034,22.205,20.079,22.205,37.857c0,17.83-9.394,32.91-22.319,37.9h56.064 c0-9.509,7.883-17.218,17.606-17.218v-41.322C202.787,166.873,194.904,159.164,194.904,149.656z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 187.337,
    cy: 189.337,
    rx: 7.192,
    ry: 7.209
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 174.617,
    cy: 84.577,
    rx: 32.062,
    ry: 32.138
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 181.02,
    y1: 102.917,
    x2: 181.843,
    y2: 105.273
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 167.556,
    y1: 64.354,
    x2: 168.432,
    y2: 66.863
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M177.929,69.608c-0.756-0.47-4.624-2.772-9.229-1.482c-3.448,0.966-7.452,3.985-7.681,8.123c-0.144,2.615,1.224,5.58,3.622,7.226 c5.627,3.862,12.378-2.663,18.759,1.129c2.603,1.547,4.611,4.493,4.657,7.492c0.07,4.567-4.429,7.842-7.338,9.104 c-5.75,2.495-11.213-0.302-12.029-0.736"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.623,
    cy: 48.778,
    rx: 30.698,
    ry: 30.771
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 78.982,
    y1: 66.792,
    x2: 78.386,
    y2: 69.106
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 88.74,
    y1: 28.916,
    x2: 88.105,
    y2: 31.38
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M94.207,38.632c-0.352-0.777-2.209-4.673-6.559-6.103c-3.257-1.071-8.047-0.804-10.426,2.368 c-1.503,2.004-1.988,5.094-0.954,7.683c2.428,6.076,11.266,4.484,14.332,10.906c1.251,2.62,1.284,6.036-0.272,8.447 c-2.369,3.673-7.689,3.878-10.674,3.331c-5.902-1.082-8.765-6.222-9.184-7.003"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.8e80d49300d128470b04cf1107a69c44.svg";
export { ForwardRef as ReactComponent };